import { tasksAPI } from '../../api';

const state = () => ({});

const mutations = {};

const actions = {
    async getTasks(_, data) {
        const tasks = await tasksAPI.getTasksAPI(data.page, data.size, data.isGroupTask);
        return { tasks: tasks.data._embedded.userTasks, page: tasks.data.page };
    },
    async acceptTask(_, data) {
        const body = {
            comments: data.comments,
            taskId: data.taskId,
            isGroupTask: data.isGroupTask,
        };
        const res = await tasksAPI.acceptTaskAPI(data.requestId, body);
        return res.data;
    },
    async rejectTask(_, data) {
        const body = {
            comments: data.comments,
            taskId: data.taskId,
            isGroupTask: data.isGroupTask,
        };
        const res = await tasksAPI.rejectTaskAPI(data.requestId, body);
        return res.data;
    },
};

export default {
    state,
    mutations,
    actions,
};
